export default __webpack_public_path__ + "static/Photography_Main-a2163b858a9ad43f674607a9a77c37e1.jpeg";